exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".nav {\n\tbackground: #fff;\n}\n\n.nav h4 {\n\tpadding: 1.75rem 0 0.75rem 2.6rem;\n}\n\n.nav-tree li .slds-tree__item {\n\tpadding-top: 3px;\n\tpadding-bottom: 3px;\n}\n\n.nav-tree li a {\n\tpadding-top: 2px;\n} \n\n.nav-tree li div.slds-is-selected a {\n\tcolor: #006ED5;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/Nav/nav.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/Nav/nav.css
// module chunks = 0